// Which tenant this PWA is for. In production the browser's Origin
// (e.g. cbm-movement.njoy.live) tells the API; locally, set
// REACT_APP_TENANT_SLUG to try another tenant's site on localhost.
export const tenantSlug = (process.env.REACT_APP_TENANT_SLUG || "").trim();

export const tenantHeaders = (): Record<string, string> =>
  tenantSlug ? { "x-tenant-slug": tenantSlug } : {};
